import './components/SaasHeadingTypography.css';
import './components/VerifiedNativePricingCalculator.css';
import './components/ChatBotPricingCalculator.css';
import "./components/SaasReferenceSources.css";
import "./pages/SellerSpriteLayout.css";
import './components/MesaUsageCalculator.css';
import './components/SaasPageHeading.css';
import './components/SaasHeadingPresentation20261009.css';
import './styles.css';
import './components/ToolMediaGallery.css';
import './components/SaasApiConnections.css';
import './components/SaasSalesSection.css';
import './components/MarketplaceAdProsPricing.css';
import './components/SaasSelectionAdvice.css';
import './components/SaasCompetitorComparison.css';
import './pages/intent-copy-highlight.css';
import './components/SaasAutomationPlatform.css';
import './components/SaasBudgetCalculator.css';
import './components/FreshworksPurchaseSelector.css';
import './components/JasperNeedsSelector.css';
import './components/LokaliseNeedsSelector.css';
import './components/SmartscoutNeedsSelector.css';
import { StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PublicDocument } from './components/PublicDocument';
import { installNetworkErrorNotifications } from './lib/networkErrors';
import { installDetailDocumentNavigation } from './lib/detailDocument';

installNetworkErrorNotifications();
installDetailDocumentNavigation();
hydrateRoot(document.getElementById('root')!, <StrictMode><BrowserRouter>
  <PublicDocument pathname={window.location.pathname} />
</BrowserRouter></StrictMode>);
